import { Component } from "react";
import TicketForm from "./TicketForm/TicketForm";
import WarningForm from "./WarningForm/WarningForm";
import { DefendantBackHalf } from "./DefendantBackHalf/DefendantBackHalf";
import DefendantPlea from "./DefendantPlea/DefendantPlea";
import styles from "./vcvc_styles.module.css";

class VCVC extends Component {
  render() {
    if (!this.props.isWarning) {
      return (
        <div
          style={
            !this.props.showDialog
              ? { margin: "0", padding: "0", height: "7.5in", width: "10in" }
              : { margin: "0", padding: "0" }
          }
        >
          <div
            className={
              !this.props.showDialog
                ? `${styles["page-container"]} ${styles["space-between"]}`
                : styles["modal-space-between"]
            }
          >
            <TicketForm
              ticket={this.props.ticket}
              defendantCopy={this.props.defendantCopy}
              bac={this.props.bac}
              showDialog={this.props.showDialog}
            />
            {!this.props.showDialog && <DefendantPlea props />}
          </div>

          {!this.props.showDialog && (
            <div
              className={`${styles["page-container"]} ${styles["space-between"]} ${styles["page-break-before"]}`}
            >
              <TicketForm
                ticket={this.props.ticket}
                defendantCopy={this.props.defendantCopy}
                bac={this.props.bac}
                showDialog={this.props.showDialog}
              />
              <DefendantBackHalf />
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div style={{ margin: "0", padding: "0" }}>
          <div
            className={`${styles["page-container"]} ${styles["ticket-container"]}`}
          >
            <WarningForm
              ticket={this.props.ticket}
              defendantCopy={this.props.defendantCopy}
              bac={this.props.bac}
              showDialog={this.props.showDialog}
            />
          </div>
        </div>
      );
    }
  }
}

export default VCVC;
